import "./Index.bs.js";
import "./globals.scss";
